import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Spinner } from 'react-bootstrap';
import { URI_INTERNAL } from '../../utils/pathLocations';
import { 
    NHAN_VIEN_API, 
    BAI_BAO_API, 
    DE_TAI_NHAN_VIEN_API, 
    SANG_CHE_API, 
    GIAI_THUONG_API, 
    SACH_API, 
    HUONG_DAN_HOC_VIEN_API, 
    GIAI_THUONG_DAO_TAO_API,
    ACCOUNT_API,
    BaseGatewayImage
} from '@app/utils/apiUrl';
import { Get } from '@app/utils/httpProvider';
import { getInfomationAccountFromToken, formatDateTimeWithoutHour } from '@app/utils/helper';
import { HOC_VI, CHUC_DANH_KH } from '@app/utils/define';
import PrintLayoutV2 from '../HoSo/components/PrintLayoutV2';

const CardItem = ({ count, title, color, path, icon = "fa-users" }) => {
    const history = useHistory();
    const [hover, setHover] = useState(false);
    return (
        <div className="col-lg-3 col-md-6 col-sm-6 col-12 mb-4">
            <div 
                onClick={() => history.push(path)}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                style={{
                    backgroundColor: color,
                    color: 'white',
                    padding: '24px 20px',
                    borderRadius: '8px',
                    position: 'relative',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    transform: hover ? 'translateY(-5px)' : 'none',
                    boxShadow: hover ? '0 10px 20px rgba(0,0,0,0.15)' : '0 4px 6px rgba(0,0,0,0.08)',
                    overflow: 'hidden',
                    height: '135px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                }}
            >
                <h2 style={{ fontSize: '38px', fontWeight: 'bold', margin: '0 0 6px 0', zIndex: 2, lineHeight: 1 }}>{count}</h2>
                <div style={{ fontSize: '15px', fontWeight: '500', zIndex: 2, whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.2' }}>{title}</div>
                <i 
                    className={`fas ${icon}`} 
                    style={{ 
                        position: 'absolute', 
                        right: '5px', 
                        bottom: '-5px', 
                        fontSize: '90px', 
                        opacity: 0.12,
                        zIndex: 1,
                        pointerEvents: 'none'
                    }} 
                />
            </div>
        </div>
    );
};

const Welcome = () => {
    const history = useHistory();
    
    // Lấy thông tin user hiện tại và phân quyền
    const currentUser = getInfomationAccountFromToken();
    const roles = currentUser?.role ? currentUser.role.split(',').map(r => r.trim().toLowerCase()) : [];
    const isAdminOrManager = roles.includes('admin') || roles.includes('manager') || roles.includes('publisher');

    // State cho user thường
    const [hoSo, setHoSo] = useState(null);
    const [nhanVien, setNhanVien] = useState(null);
    const [loadingNhanVien, setLoadingNhanVien] = useState(true);

    useEffect(() => {
        if (!isAdminOrManager && currentUser?.id) {
            setLoadingNhanVien(true);
            Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, currentUser.id)
                .then(accRes => {
                    if (accRes && accRes.nhanVienId) {
                        return Get(NHAN_VIEN_API.GET_HOSO_CV, accRes.nhanVienId);
                    }
                    return null;
                })
                .then(async empRes => {
                    if (empRes && !empRes.error) {
                        setHoSo(empRes);
                        try {
                            // Lấy thêm thông tin chi tiết nhân viên để bù đắp các trường giới thiệu bản thân bị thiếu
                            const detailRes = await Get(NHAN_VIEN_API.GET_BY_ID, empRes.nhanVien.id);
                            if (detailRes && !detailRes.error) {
                                setNhanVien({ ...empRes.nhanVien, ...detailRes });
                            } else {
                                setNhanVien(empRes.nhanVien);
                            }
                        } catch (e) {
                            console.error("Lỗi lấy thông tin chi tiết nhân viên:", e);
                            setNhanVien(empRes.nhanVien);
                        }
                    }
                })
                .catch(err => console.error("Lỗi tải thông tin nhân viên:", err))
                .finally(() => setLoadingNhanVien(false));
        } else {
            setLoadingNhanVien(false);
        }
    }, [isAdminOrManager, currentUser?.id]);

    // Các queries cho Admin/Manager dashboard
    const { data: dataNhanVien } = useQuery('countNhanVien', () =>
        Get(NHAN_VIEN_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1 }),
        { enabled: isAdminOrManager }
    );
    const { data: dataBaiBao } = useQuery('countBaiBao', () =>
        Get(BAI_BAO_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1 }),
        { enabled: isAdminOrManager }
    );
    const { data: dataDeTai } = useQuery('countDeTai', () =>
        Get(DE_TAI_NHAN_VIEN_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1 }),
        { enabled: isAdminOrManager }
    );
    const { data: dataSangChe } = useQuery('countSangChe', () =>
        Get(SANG_CHE_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1 }),
        { enabled: isAdminOrManager }
    );
    const { data: dataGiaiThuong } = useQuery('countGiaiThuong', () =>
        Get(GIAI_THUONG_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1 }),
        { enabled: isAdminOrManager }
    );
    const { data: dataSach } = useQuery('countSach', () =>
        Get(SACH_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1 }),
        { enabled: isAdminOrManager }
    );
    const { data: dataHuongDan } = useQuery('countHuongDan', () =>
        Get(HUONG_DAN_HOC_VIEN_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1 }),
        { enabled: isAdminOrManager }
    );
    const { data: dataGiaiThuongDaoTao } = useQuery('countGiaiThuongDaoTao', () =>
        Get(GIAI_THUONG_DAO_TAO_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1 }),
        { enabled: isAdminOrManager }
    );

    if (loadingNhanVien) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                <Spinner animation="border" variant="primary" />
                <span className="ml-2">Đang tải trang chủ...</span>
            </div>
        );
    }

    // 1. RENDER GIAO DIỆN ADMIN / MANAGER
    if (isAdminOrManager) {
        return (
            <div className="container-fluid pt-4">
                <div className="row">
                    <CardItem 
                        count={dataNhanVien?.totalRecords || 0} 
                        title="Danh sách giảng viên" 
                        color="#e05d4b" 
                        path={URI_INTERNAL.PROFILE_CV} 
                    />
                    <CardItem 
                        count={dataBaiBao?.totalRecords || 0} 
                        title="Bài báo được công bố" 
                        color="#2fa751" 
                        path={URI_INTERNAL.BAI_BAO_PATH} 
                    />
                    <CardItem 
                        count={dataDeTai?.totalRecords || 0} 
                        title="Nhiệm vụ khoa học công nghệ" 
                        color="#2872cc" 
                        path={URI_INTERNAL.DE_TAI_PATH} 
                    />
                    <CardItem 
                        count={dataSangChe?.totalRecords || 0} 
                        title="Sáng chế, giải pháp hữu ích" 
                        color="#8f3bb2" 
                        path={URI_INTERNAL.SANG_CHE_PATH} 
                    />
                </div>
                <div className="row">
                    <CardItem 
                        count={dataGiaiThuong?.totalRecords || 0} 
                        title="Giải thưởng NCKH" 
                        color="#92cc4e" 
                        path={URI_INTERNAL.GIAI_THUONG_PATH} 
                    />
                    <CardItem 
                        count={dataSach?.totalRecords || 0} 
                        title="Sách chuyên khảo, giáo trình" 
                        color="#dd8423" 
                        path={URI_INTERNAL.SACH_PATH} 
                    />
                    <CardItem 
                        count={dataHuongDan?.totalRecords || 0} 
                        title="Nghiên cứu sinh, học viên" 
                        color="#2aa38a" 
                        path={URI_INTERNAL.HUONG_DAN_HOC_VIEN_PATH} 
                    />
                    <CardItem 
                        count={dataGiaiThuongDaoTao?.totalRecords || 0} 
                        title="Giải thưởng về đào tạo" 
                        color="#b5b820" 
                        path={URI_INTERNAL.GIAI_THUONG_DAO_TAO_PATH} 
                    />
                </div>
            </div>
        );
    }

    // 2. RENDER GIAO DIỆN USER THƯỜNG (GIẢNG VIÊN / NHÂN VIÊN)
    const getChucDanhAbbr = (val) => {
        if (val === 24) return 'PGS';
        if (val === 25) return 'GS';
        return '';
    };

    const getHocViAbbr = (val) => {
        if (val === 22) return 'TS';
        if (val === 23) return 'TSKH';
        if (val === 21) return 'Thạc sĩ';
        if (val === 20) return 'BSNT';
        if (val === 19) return 'BSCKII';
        if (val === 18) return 'BSCKI';
        if (val === 16) return 'BS';
        if (val === 17) return 'DS';
        if (val === 15) return 'Cử nhân';
        return '';
    };

    const cdText = getChucDanhAbbr(nhanVien?.chucDanhKHCaoNhat);
    const hvText = getHocViAbbr(nhanVien?.hocViCaoNhat);

    // PGS TS Bùi Tiến Sỹ
    const chucDanhHocViHoTen = [cdText, hvText, nhanVien?.hoTen || currentUser?.fullname || currentUser?.fullName].filter(Boolean).join(' ');

    // PGS, TS Bùi Tiến Sỹ (hiển thị trong card)
    const chucDanhHocViHoTenCard = [
        cdText ? `${cdText},` : '',
        hvText,
        nhanVien?.hoTen || currentUser?.fullname || currentUser?.fullName
    ].filter(Boolean).join(' ').replace(', ', ', ');

    const rawUpdateDate = nhanVien?.p_NGAYCAPNHAT || nhanVien?.P_NGAYCAPNHAT || nhanVien?.p_NGAYCAPNHAP || nhanVien?.P_NGAYCAPNHAP || nhanVien?.updatedAt;
    const updateDateStr = (rawUpdateDate && !String(rawUpdateDate).startsWith('0001')) 
        ? formatDateTimeWithoutHour(rawUpdateDate) 
        : 'Chưa cập nhật';

    const quaTrinhDaoTao = hoSo?.quaTrinhDaoTao || [];
    const ngoaiNgu = hoSo?.ngoaiNgu || [];
    const baiBao = hoSo?.baiBao || [];
    const deTai = hoSo?.deTai || [];
    const sangChe = hoSo?.sangChe || [];
    const sach = hoSo?.sach || [];
    const huongDanHocVien = hoSo?.huongDanHocVien || [];
    const tenDonVi = hoSo?.tenDonVi || '';

    return (
        <>
            <div className="container-fluid pt-2 px-4 d-print-none">
                {/* Thanh chào trên cùng */}
                <div 
                    style={{ 
                        backgroundColor: '#e8f0fe', 
                        borderLeft: '4px solid #3c8dbc',
                        color: '#1a5a96', 
                        padding: '12px 20px', 
                        borderRadius: '4px', 
                        marginBottom: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        fontWeight: '500',
                        fontSize: '16px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                    }}
                >
                    <i className="fas fa-arrow-alt-circle-right mr-2" style={{ fontSize: '18px', color: '#3c8dbc' }} />
                    Xin chào {chucDanhHocViHoTen}{nhanVien?.maNhanVien ? `, Mã nhân viên: ${nhanVien.maNhanVien}` : ''}
                </div>

                <div className="row">
                    {/* Cột trái: Thông tin cá nhân */}
                    <div className="col-lg-4 col-md-5 col-12 mb-4">
                        <div 
                            className="card shadow-sm border-0" 
                            style={{ 
                                borderRadius: '8px',
                                padding: '30px 20px',
                                backgroundColor: '#fff'
                            }}
                        >
                            {/* Avatar */}
                            {nhanVien?.hinhAnh ? (
                                <img 
                                    src={nhanVien.hinhAnh.startsWith('http') ? nhanVien.hinhAnh : (BaseGatewayImage + nhanVien.hinhAnh)} 
                                    alt="Avatar" 
                                    style={{ 
                                        width: '120px', 
                                        height: '120px', 
                                        borderRadius: '50%', 
                                        objectFit: 'cover',
                                        margin: '0 auto 15px auto',
                                        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                                        border: '3px solid #f8f9fc',
                                        display: 'block'
                                    }}
                                />
                            ) : (
                                <div 
                                    style={{ 
                                        width: '120px', 
                                        height: '120px', 
                                        borderRadius: '50%', 
                                        backgroundColor: '#4e73df', 
                                        display: 'flex', 
                                        justifyContent: 'center', 
                                        alignItems: 'center',
                                        margin: '0 auto 15px auto',
                                        boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    <i className="fas fa-user" style={{ fontSize: '60px', color: 'white' }} />
                                </div>
                            )}

                            <div className="text-center mt-3">
                                <h5 style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {chucDanhHocViHoTenCard}
                                    <i className="fas fa-check-circle text-primary ml-1" style={{ fontSize: '15px' }} />
                                </h5>
                                <p className="text-muted mb-2" style={{ fontSize: '14px' }}>
                                    Số CMND/CCCD: {nhanVien?.soCMND_CCCD || ''}
                                </p>
                                <p style={{ fontWeight: '500', color: '#333', fontSize: '14px', marginBottom: '15px' }}>
                                    {nhanVien?.emailCongViec || currentUser?.email || ''}
                                </p>
                                
                                {/* Link xem lý lịch */}
                                <div className="mb-4">
                                    <span 
                                        style={{ 
                                            cursor: 'pointer', 
                                            color: '#6c757d', 
                                            fontSize: '13px',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            padding: '5px 10px',
                                            borderRadius: '4px',
                                            backgroundColor: '#f8f9fa'
                                        }} 
                                        onClick={() => {
                                            if (hoSo) {
                                                window.print();
                                            }
                                        }}
                                        className="hover-bg-light"
                                    >
                                        <i className="fas fa-file-alt" style={{ fontSize: '14px' }} /> Xem Lý lịch khoa học
                                    </span>
                                </div>

                                {/* Button cập nhật thông tin */}
                                <button 
                                    className="btn btn-success" 
                                    style={{ 
                                        borderRadius: '20px', 
                                        padding: '8px 25px', 
                                        fontWeight: '500', 
                                        backgroundColor: '#2d9d78',
                                        borderColor: '#2d9d78',
                                        boxShadow: '0 2px 5px rgba(45,157,120,0.2)'
                                    }}
                                    onClick={() => {
                                        if (nhanVien?.id) {
                                            history.push(`${URI_INTERNAL.NHAN_VIEN_INPUT}/${nhanVien.id}`);
                                        } else {
                                            history.push(URI_INTERNAL.NHAN_VIEN_INPUT);
                                        }
                                    }}
                                >
                                    Cập nhật thông tin
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Cột phải: Hướng dẫn */}
                    <div className="col-lg-8 col-md-7 col-12 mb-4">
                        {/* Card trên: Trạng thái cập nhật */}
                        <div 
                            className="card shadow-sm border-0 mb-4" 
                            style={{ 
                                borderRadius: '8px',
                                padding: '20px',
                                backgroundColor: '#fff'
                            }}
                        >
                            <h6 style={{ fontWeight: 'bold', color: '#333', marginBottom: '10px' }}>
                                Hoàn thiện thông tin lý lịch khoa học bằng cách bấm vào Cập nhật thông tin
                            </h6>
                            <small className="text-muted italic">
                                Đã cập nhật ngày: {updateDateStr}
                            </small>
                        </div>

                        {/* Card dưới: Các bước hướng dẫn */}
                        <div 
                            className="card shadow-sm border-0" 
                            style={{ 
                                borderRadius: '8px',
                                padding: '24px 20px',
                                backgroundColor: '#fff'
                            }}
                        >
                            <h6 style={{ fontWeight: 'bold', color: '#333', marginBottom: '15px' }}>
                                Các bước để hoàn thiện các thông tin trong lý lịch khoa học
                            </h6>
                            <ul 
                                style={{ 
                                    listStyleType: 'disc', 
                                    paddingLeft: '20px', 
                                    margin: '0',
                                    color: '#333',
                                    fontSize: '14px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px'
                                }}
                            >
                                <li>
                                    <strong>Bước 1.</strong> Điền thông tin tại mục &lt;&lt; <strong>Thông tin chung</strong> &gt;&gt;
                                </li>
                                <li>
                                    <strong>Bước 2.</strong> Bổ sung thông tin bài báo, nhiệm vụ, sáng chế, giải thưởng tại mục &lt;&lt; <strong>Hoạt động nghiên cứu</strong> &gt;&gt;
                                </li>
                                <li>
                                    <strong>Bước 3.</strong> Bổ sung thông tin sách chuyên khảo, giáo trình, hướng dẫn NCS, Học viên tại mục &lt;&lt; <strong>Hoạt động đào tạo</strong> &gt;&gt;
                                </li>
                                <li>
                                    <strong>Bước 4.</strong> Xem lại thông tin và tải xuống CV tại mục <strong>Thông tin &gt;&gt; Xem và In</strong>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Print layout v2 ẩn, chỉ hiển thị khi in */}
            {hoSo && (
                <PrintLayoutV2
                    nhanVien={nhanVien}
                    tenDonVi={tenDonVi}
                    quaTrinhDaoTao={quaTrinhDaoTao}
                    ngoaiNgu={ngoaiNgu}
                    baiBao={baiBao}
                    deTai={deTai}
                    sangChe={sangChe}
                    sach={sach}
                    huongDanHocVien={huongDanHocVien}
                />
            )}
        </>
    );
};

export default Welcome;
